import React from 'react';
import { createIcon } from 'components/shared/SVGIcon';

const CopyIcon = createIcon(
  'Copy',
  <path d="M15,20 L5,20 L5,7 C5,6.45 4.55,6 4,6 L4,6 C3.45,6 3,6.45 3,7 L3,20 C3,21.1 3.9,22 5,22 L15,22 C15.55,22 16,21.55 16,21 L16,21 C16,20.45 15.55,20 15,20 Z M20,16 L20,4 C20,2.9 19.1,2 18,2 L9,2 C7.9,2 7,2.9 7,4 L7,16 C7,17.1 7.9,18 9,18 L18,18 C19.1,18 20,17.1 20,16 Z M18,16 L9,16 L9,4 L18,4 L18,16 Z" />
);

export default CopyIcon;
